import { ESdChangeReason, ESymbolCategory, IAction, IActionParameter, ISymbol } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { IActionPanelStatesCanBeUpdatedFromChild } from "./action-panel";
import ActionParameterTitle from "./action-parameter-title";
import { isActionParameterShownInPanel } from "./action-parameter-visibility";
import { SymbolPicker } from "./symbol-picker";

const OPEN_AS_OPTIONS: KuikaSelectboxOption[] = [
  { key: "current", value: "current", label: "Current Page" },
  { key: "newtab", value: "newtab", label: "New Tab" }
];

export interface IOpenInBrowserSymbolsGroupState {}

export interface IOpenInBrowserSymbolsGroupProps {
  action: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild) => void;
  changeActionParameter: (parameter: IActionParameter, symbol: ISymbol, changeReason?: ESdChangeReason) => void;
}

class OpenInBrowserSymbolsGroup extends PureSdComponent<
  IOpenInBrowserSymbolsGroupProps & IWithSDProps & IWithContextProp,
  IOpenInBrowserSymbolsGroupState
> {
  constructor(props: IOpenInBrowserSymbolsGroupProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  handleOpenAsChange = (value: string): void => {
    let fixedValue = value;

    const params = _.cloneDeep(this.props.parameters);
    const _parameter = params.find((element) => element.name === "openAs")!;
    if (_parameter === undefined) {
      return;
    }
    if (!_parameter.symbol) _parameter.symbol = {} as any;
    _parameter.symbol.fixedValue = fixedValue;
    _parameter.symbol.category = ESymbolCategory.fixed;
    let valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    this.props.updateValues(valuesToUpdate);
  };

  renderOpenAs = (): JSX.Element => {
    let openAsParam = this.props.parameters.find((element) => element.name === "openAs");
    return (
      <>
        <div style={{ marginTop: 12 }} className="kuika_add_actions_properties_name">
          Open As
        </div>
        <div className="kuika_property-grid-column">
          <KuikaSelectbox
            searchable
            size="sm"
            style={{ width: "100%" }}
            value={openAsParam?.symbol.fixedValue ?? "current"}
            onChange={this.handleOpenAsChange}
            className="kuika_add_actions_inputs_size"
            options={OPEN_AS_OPTIONS}
          />
        </div>
      </>
    );
  };

  render() {
    const openAsParam = this.props.parameters?.find((element) => element.name === "openAs");
    return (
      <div style={{ width: "100%" }}>
        {openAsParam && openAsParam.isExternalVisible === true && this.renderOpenAs()}
        {this.props.parameters
          ?.filter((parameter: IActionParameter): boolean => isActionParameterShownInPanel(parameter))
          .map((parameter, id) => {
            return (
              parameter.name !== "openAs" && (
                <div key={id}>
                  <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
                    <ActionParameterTitle parameter={parameter} />
                  </span>
                  {
                    <SymbolPicker
                      action={this.props.action}
                      changeType="onBlur"
                      symbol={parameter.symbol}
                      valueType={parameter.Typename}
                      targetCardinality={parameter.cardinality}
                      onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
                        this.props.changeActionParameter(parameter, symbol, changeReason)
                      }
                      bindingParameter={parameter}
                    ></SymbolPicker>
                  }
                </div>
              )
            );
          })}
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.DiActionUpdated ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const openInBrowserSymbolsGroup = withContext<IOpenInBrowserSymbolsGroupProps>(
  withSD<IOpenInBrowserSymbolsGroupProps>(OpenInBrowserSymbolsGroup)
);
export { openInBrowserSymbolsGroup as OpenInBrowserSymbolsGroup };
